import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currency: [],
    billType: [
        { id: 1, name: "مشتريات" }, { id: 2, name: "مبيعات" }, { id: 3, name: "مردود مبيعات" }, { id: 4, name: "مردود مشتريات" }, { id: 5, name: "ادخال" }, { id: 6, name: "اخراج" }, { id: 7, name: "بضاعة افتتاحية" }, { id: 8, name: "اتلاف" }, { id: 9, name: "نقابة و تأمين" }
    ],
    Warehouses: [],
    lastUpdatedCurrency: localStorage.getItem('lastUpdatedCurrency') || null,

}

const StaticDataSlice = createSlice({
    name: 'staticData',
    initialState,
    reducers: {
        setWarehouses: (state, action) => {
            state.Warehouses = !!action?.payload ? action?.payload : state.state;
        },
        setCurrency: (state, action) => {
            state.currency = !!action?.payload ? action?.payload?.data : state.state;
            state.lastUpdatedCurrency = new Date().toISOString();
            localStorage.setItem('lastUpdatedCurrency', state.lastUpdatedCurrency);
        },
        initialCurrency: (state, action) => {
            state.currency = [];
            state.Warehouses = [];
            state.lastUpdatedCurrency = null;
            localStorage.clear(); // حفظ وقت التحديث في localStorage
        },
        // changeBridg: (state, action) => {
        //     state.bridg = !!action?.payload?.bridg ? action?.payload?.bridg : state.bridg;
        // },
        // reset: () => initialState
    },
});
export const {
    // reset,
    // changeApp,
    // changeBridg
    setWarehouses,
    setCurrency,
    initialCurrency
} = StaticDataSlice.actions;

export default StaticDataSlice.reducer;
